import type { ReactNode } from 'react';
import { BreadcrumbChild } from './styled';

interface Props {
  active?: boolean;
  children: ReactNode;
}
const BreadcrumbSection = ({ active = false, children }: Props) => (
  <BreadcrumbChild active={active}>{children}</BreadcrumbChild>
);

export default BreadcrumbSection;
